import { render, staticRenderFns } from "./contactUsAdmin.vue?vue&type=template&id=128fe1fc&"
import script from "./contactUsAdmin.vue?vue&type=script&lang=js&"
export * from "./contactUsAdmin.vue?vue&type=script&lang=js&"
import style0 from "./contactUsAdmin.vue?vue&type=style&index=0&id=128fe1fc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports